export default __webpack_public_path__ + "static/media/ny.2fa38ed1.PNG";